// Отправка пользовательских событий лендинга в dataLayer (Google Tag Manager → GA4).
// Имена событий и параметры соответствуют ТЗ «Отслеживание событий на speend.io».

// Все параметры, которые мы когда-либо пушим. Перед каждым событием обнуляем их,
// иначе ключи предыдущего события «тянутся» в модель dataLayer следующего (шлейф).
const ALL_PARAM_KEYS = [
  'button_text',
  'button_location',
  'destination_url',
  'platform',
  'link_url',
  'doc_name',
  'doc_url',
  'form_name',
  'form_location',
  'error_fields',
  'page_path',
];

export function pushDataLayer(event, params) {
  window.dataLayer = window.dataLayer || [];

  const cleared = {};
  ALL_PARAM_KEYS.forEach((key) => {
    cleared[key] = undefined;
  });

  window.dataLayer.push({ event, ...cleared, ...params });
}

function pagePath() {
  return window.location.pathname;
}

// aria-label иконки соцсети → значение platform по ТЗ.
function normalizePlatform(label) {
  const map = {
    linkedin: 'linkedin',
    medium: 'medium',
    telegram: 'telegram',
    x: 'twitter',
    twitter: 'twitter',
  };
  const key = (label || '').trim().toLowerCase();
  return map[key] || key;
}

function absoluteUrl(href) {
  if (!href) return undefined;
  try {
    return new URL(href, window.location.origin).href;
  } catch (e) {
    return href;
  }
}

// cta_click — клик по любой CTA-кнопке с атрибутом data-ga-cta.
function handleCtaClick(el) {
  const params = {
    button_text: (el.textContent || '').trim(),
    button_location: el.dataset.gaCta,
    page_path: pagePath(),
  };

  // destination_url — только если есть реальный переход (ссылка, а не открытие модалки).
  const href = el.getAttribute('href');
  if (href && href !== '#' && !el.hasAttribute('data-bs-toggle')) {
    params.destination_url = absoluteUrl(href);
  }

  pushDataLayer('cta_click', params);

  // Если кнопка открывает модалку с формой — прокидываем контекст формы
  // (form_name / form_location) в саму форму, чтобы submit_request/form_error
  // знали, из какой секции открыта форма.
  if (el.dataset.gaFormName) {
    const target = el.getAttribute('data-bs-target');
    const form = target ? document.querySelector(`${target} form`) : null;
    if (form) {
      form.dataset.gaFormName = el.dataset.gaFormName;
      form.dataset.gaFormLocation = el.dataset.gaFormLocation || '';
    }
  }
}

// social_click — клик по иконке соцсети в футере.
function handleSocialClick(el) {
  pushDataLayer('social_click', {
    platform: normalizePlatform(el.getAttribute('aria-label')),
    link_url: absoluteUrl(el.getAttribute('href')),
    page_path: pagePath(),
  });
}

// doc_click — клик по ссылке на PDF-документ в футере.
function handleDocClick(el) {
  pushDataLayer('doc_click', {
    doc_name: (el.textContent || '').trim(),
    doc_url: absoluteUrl(el.getAttribute('href')),
    page_path: pagePath(),
  });
}

export function initAnalytics() {
  document.addEventListener('click', (e) => {
    const cta = e.target.closest('[data-ga-cta]');
    if (cta) {
      handleCtaClick(cta);
      return;
    }

    const social = e.target.closest('.footer--socials a[aria-label]');
    if (social) {
      handleSocialClick(social);
      return;
    }

    const doc = e.target.closest('.nav-documents a[href]');
    if (doc) {
      handleDocClick(doc);
    }
  });
}
